import { render, staticRenderFns } from "./PoIndex.vue?vue&type=template&id=ec0b1276&scoped=true&"
import script from "./PoIndex.vue?vue&type=script&lang=js&"
export * from "./PoIndex.vue?vue&type=script&lang=js&"
import style0 from "./PoIndex.vue?vue&type=style&index=0&id=ec0b1276&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec0b1276",
  null
  
)

export default component.exports